/**
 * Takes a const string template e.g. 'hello %s' and replaces it with passed in values
 * @param  {string} [template='%s']   String template to fill
 * @param  {Array}  [input=[]]        Array of values to use to fill in
 * @return {string}                   Resultant string
 */
export default (template, input = []) => {
  const newTemplate = template || '%s' // assume input fills if template unspecified/null
  const newInput = Array.isArray(input) ? input.slice() : [input]
  return newTemplate.replace(/%s/g, () => newInput.shift())
}
